module.exports = __webpack_public_path__ + "static/fin2-4c1cca5197ef298888024982aeb013bf.jpg";